import './js/footer.js';
import './js/cards';
import './js/dark-mode';
import './js/spinner.js';
import './js/search.js';
import './js/apifetch.js';
import './js/pagination.js';
import './js/modal.js';
import './js/imports.js';
import { setupPagination } from './js/apifetch.js';
setupPagination();
